import { Provider } from '@angular/core';

import { provide } from '@kros-sk/core/di';

import { APPLICATION_SUBMODULE_API_URL, ApplicationCurrentSubmoduleApiService } from './application-current-submodule-api.service';
import { ApplicationCurrentSubmoduleStore } from './application-current-submodule.store';

export interface SubmoduleConfig {
  apiUrlSubmodule: string;
}

export function provideSubmodule(config: SubmoduleConfig): Provider[] {
  return [
    provide(APPLICATION_SUBMODULE_API_URL, { useValue: config.apiUrlSubmodule }),
    ApplicationCurrentSubmoduleApiService,
    ApplicationCurrentSubmoduleStore,
  ];
}
